import { useEffect, RefObject } from 'react';

export function useClickOutsideWithExceptions(
    ref: RefObject<HTMLElement | null>,
    state: unknown,
    callback: (state?: unknown, event?: Event, exceptionMatch?: Element | null) => void,
    exceptionSelector?: string,
    buttonRef?: RefObject<HTMLElement | null>,
) {
    useEffect(() => {
        function handleClickOutside(event: Event) {
            const targetNode = event.target as Node | null;
            if (
                ref.current &&
                !ref.current.contains(targetNode) &&
                (!buttonRef?.current || !buttonRef.current.contains(targetNode))
            ) {
                const target = event.target as Element | null;
                const exceptionMatch = exceptionSelector && target ? target.closest(exceptionSelector) : null;
                callback(state, event, exceptionMatch);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('touchend', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchend', handleClickOutside);
        };
    }, [ref, state, callback, exceptionSelector, buttonRef]);
}
